import moment from "moment";

export const time = (value) => {
	if (!value) return ''
	return typeof value === 'string' ? moment(String(value)).format('h:mm A') : value;
};
